import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Customer } from 'app/shared/types/customer';
import { CustomerService } from 'app/shared/services/customer.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';


@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  bankAccountList : any[];

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  customer:Customer;
  addCustomerForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  
  validationMessages = {
    'guestId' : { 'required': 'This field is required' },
    'guestName' : { 'required': 'This field is required' },
    'address' : { 'required': 'This field is required' },
    'country' : { 'required': 'This field is required' },
    'phone' : { 'required': 'This field is required' },
    'email': {'email': 'Email must be a valid email address'}, 
    'bookingSource' : { 'required': 'This field is required' },
    'checkedIn' : { 'required': 'This field is required' },
  
  };

  formErrors = {
    'guestId' : "",
    'guestName' : "",
    'address' : "",
    'country' : "",
    'phone' : "",
    'email' : "",
    'bookingSource' : "",
    'checkedIn' : "",

  };


  genderList =[
    {value: 'Male'},
    {value: 'Female'},

  ];

  packageList =[
    {value: 'Day outing Package'},
    {value: 'Candle Light dinner Package for the Couple'},
    {value: 'Wilpaththu Safari Package'},
    {value: 'Gage Wadiya Package'},
    {value: 'Dolphin Watching Package'},
    {value: 'Bathalangunduwa Night Camp Package'},
    {value: 'Thalawila Church Pilgrimage Package'},
    {value: 'Valantine Package'},
    {value: 'One Night Stay at Dinuda Package for 6500'},
    {value: 'Room Only Package'},
    {value: 'Per Person 2500 Package'},
    {value: 'BB Package'},
    {value: 'HB Package'},
    {value: 'Swimming Pool Only Package'},
    {value: 'Kayak Package'},
    {value: 'Transport Package'},

  ];


  bookingSourceList =[
    {value : 'Direct booking'},
    {value : 'Walking Guest'},
    {value : 'Travel Agent'},
    {value : 'Booking.com'},
    {value : 'Agoda.com'},
    {value : 'Expedia.com'},
    {value : 'AirBnb.com'},
    {value : 'Hotel.com'},
    {value : 'Hostelworld.com'},
    {value : 'MakeMyTrip.com'},
    {value : 'TripAdvisor.com'},
    

  ];


  roomTypeList2 =[
    {value : 'STD DBL FAN'},
    {value : 'STD DBL'},
    {value : 'STD TRPL '},
    {value : 'STD FML '},
    {value : 'SUPR DBL '},
    {value : 'SUPR TRPL'},
    {value : 'SUPR FML'},
    {value : 'SUPR KNG'},
    {value : 'DLX DBL'},    

  ];

   roomTypeList =[
    {value: 'Deluxe'},
    {value: 'Superior'},
    {value: 'Luxury'},
    {value: 'Budget'}, 
  ];


  roomNoList =[
    {value : '101'},
    {value : '102'},
    {value : '103'},
    {value : '104'},
    {value : '105'},
    {value : '106'},
    {value : '107 Single'},
    {value : '109 Sun View'},
    {value : '110 Sun View'},
    {value : '201'},
    {value : '202'},
    {value : '203'},
    {value : '204'},
    {value : '205'},
    {value : '206'},
    {value : '207'},
    {value : '208'},
    {value : 'KING'},
    {value : 'OLU'},
    {value : 'NELUM'},
    {value : 'ARALIYA'},
    {value : 'KARANDA'},

  
  
  

  ];


    constructor(private fb: FormBuilder,
                private bankAccountsService: BankAccountsService,
                private customerService: CustomerService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }
              
               

              

  ngOnInit() {

    this.getBankAccountList();
    this.customer = {
      id : null,
      guestId: '',
      guestName: '',
      address: '',
      nic: '',
      country: '',
      gender: '',
      dob: '',
      phone: '',
      email: '',
      bookingSource: '',
      roomType: '',
      package: '',
      roomNo: '',
      roomExtNo: '',
      checkedIn: '',
      checkedOut: '',
      advance: 0.00,
      depositAccount: '',
      status: '',
      createdBy: '',
      
  
    }
    
    
    this.addCustomerForm = this.fb.group({
      id : [null],
      guestId: ['',Validators.required],
      guestName: ['',Validators.required],
      address: ['',Validators.required],
      nic: [''],
      country: ['',Validators.required],
      gender: [''],
      dob: [''],
      phone: ['',Validators.required],
      email: ['',Validators.email],
      bookingSource: ['',Validators.required],
      roomType: [''],
      package: [null],
      roomNo: [''],
      roomExtNo: [''],
      checkedIn: ['',Validators.required],
      checkedOut: [''],
      advance: [''],
      depositAccount: [null],
      status: [false],

    });

  
   this.addCustomerForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.addCustomerForm);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {  
                  this.bankAccountList = data           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='CM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.addCustomerForm.value.guestId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.addCustomerForm.reset();
    this.enableForm();
    this.getMaxId();
   }

   
  
   getMaxId(){
    var customerId = 0;
    var sCustomerId : String;
  
    this.customerService.getMaxId()
    .subscribe(
      (res) => {
                  customerId = Number(res[0].MaxId) + 1;
                  sCustomerId = customerId.toString().padStart(6,'0');
                  this.addCustomerForm.patchValue({
                    guestId : "CUS" + sCustomerId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }

  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.addCustomerForm,true);
    this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.addCustomerForm.value.id){
                this.showProcessingIndicator = true;
                this.customerService.addCustomer(this.customer)
                .subscribe(
                  (res) => {

                              if(res.success === 0){
                                this.addCustomerForm.patchValue({
                                guestId : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                data=res;
                                this.toastr.success('Guest added successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                             }   

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.customerService.updateCustomer(this.customer)
            .subscribe(
              (res) => {
                          this.toastr.success('Guest updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.addCustomerForm.controls).forEach(key => {
      this.addCustomerForm.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.addCustomerForm.controls).forEach(key => {
      this.addCustomerForm.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.addCustomerForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.addCustomerForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToCustomerModel(){
    this.customer.guestId=this.addCustomerForm.value.guestId;
    this.customer.guestName=this.addCustomerForm.value.guestName;
    this.customer.address=this.addCustomerForm.value.address;
    this.customer.nic=this.addCustomerForm.value.nic;
    this.customer.country=this.addCustomerForm.value.country;
    this.customer.gender=this.addCustomerForm.value.gender;
    this.customer.dob=this.addCustomerForm.value.dob ? moment(this.addCustomerForm.value.dob).format("YYYY-MM-DD"): null;
    this.customer.phone=this.addCustomerForm.value.phone;
    this.customer.email=this.addCustomerForm.value.email;
    this.customer.bookingSource=this.addCustomerForm.value.bookingSource;
    this.customer.roomType=this.addCustomerForm.value.roomType;
    this.customer.package=this.addCustomerForm.value.package;
    this.customer.roomNo=this.addCustomerForm.value.roomNo;
    this.customer.roomExtNo=this.addCustomerForm.value.roomExtNo;
    this.customer.checkedIn=this.addCustomerForm.value.checkedIn ? moment(this.addCustomerForm.value.checkedIn).format("YYYY-MM-DD"): null;
    this.customer.checkedOut=this.addCustomerForm.value.checkedOut ? moment(this.addCustomerForm.value.checkedOut).format("YYYY-MM-DD"): null;
    this.customer.advance=this.addCustomerForm.value.advance;
    this.customer.depositAccount=this.addCustomerForm.value.depositAccount;
    if(this.addCustomerForm.value.status){
      this.customer.status='Deactivated';    
    }
    else{
      this.customer.status='Active';
    }  
    this.customer.createdBy=this.authService.getUserLoggedIn();
    
  }
   



activeStatus = false;
viewCustomer(data){
  if(data.Status=='Active'){
    this.activeStatus = false;
  }else{
    this.activeStatus = true;
  }
 
  this.addCustomerForm.patchValue({
    id : data.Id,
    guestId:data.GuestId,
    guestName:data.GuestName,
    address:data.Address,
    nic:data.NIC,
    country:data.Country,
    gender:data.Gender,
    dob:data.DOB ? moment(data.DOB).format("YYYY-MM-DD"): null,
    phone:data.Phone,
    email:data.Email,
    bookingSource:data.BookingSource,
    roomType:data.RoomType,
    package:data.Package,
    roomNo:data.RoomNo,
    roomExtNo:data.RoomExtNo,
    checkedIn:data.CheckedIn ?  moment(data.CheckedIn).format("YYYY-MM-DD"): null,
    checkedOut:data.CheckedOut ? moment(data.CheckedOut).format("YYYY-MM-DD"): null,
    advance:data.Advance,
    depositAccount:data.DepositAccount,
    status : this.activeStatus, 
   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.customerService.dataRow;
  if(data){
    this.viewCustomer(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}

countryList =[
  {value : 'Afghanistan'},
  {value : 'Albania'},
  {value : 'Algeria'},
  {value : 'American Samoa'},
  {value : 'Andorra'},
  {value : 'Angola'},
  {value : 'Anguilla'},
  {value : 'Antarctica'},
  {value : 'Antigua and Barbuda'},
  {value : 'Argentina'},
  {value : 'Armenia'},
  {value : 'Aruba'},
  {value : 'Australia'},
  {value : 'Austria'},
  {value : 'Azerbaijan'},
  {value : 'Bahamas'},
  {value : 'Bahrain'},
  {value : 'Bangladesh'},
  {value : 'Barbados'},
  {value : 'Belarus'},
  {value : 'Belgium'},
  {value : 'Belize'},
  {value : 'Benin'},
  {value : 'Bermuda'},
  {value : 'Bhutan'},
  {value : 'Bolivia'},
  {value : 'Bosnia and Herzegowina'},
  {value : 'Botswana'},
  {value : 'Bouvet Island'},
  {value : 'Brazil'},
  {value : 'British Indian Ocean Territory'},
  {value : 'Brunei Darussalam'},
  {value : 'Bulgaria'},
  {value : 'Burkina Faso'},
  {value : 'Burundi'},
  {value : 'Cambodia'},
  {value : 'Cameroon'},
  {value : 'Canada'},
  {value : 'Cape Verde'},
  {value : 'Cayman Islands'},
  {value : 'Central African Republic'},
  {value : 'Chad'},
  {value : 'Chile'},
  {value : 'China'},
  {value : 'Christmas Island'},
  {value : 'Cocos (Keeling) Islands'},
  {value : 'Colombia'},
  {value : 'Comoros'},
  {value : 'Congo'},
  {value : 'Congo, the Democratic Republic of the'},
  {value : 'Cook Islands'},
  {value : 'Costa Rica'},
  {value : "Cote d'Ivoire"},
  {value : 'Croatia (Hrvatska)'},
  {value : 'Cuba'},
  {value : 'Cyprus'},
  {value : 'Czech Republic'},
  {value : 'Denmark'},
  {value : 'Djibouti'},
  {value : 'Dominica'},
  {value : 'Dominican Republic'},
  {value : 'East Timor'},
  {value : 'Ecuador'},
  {value : 'Egypt'},
  {value : 'El Salvador'},
  {value : 'Equatorial Guinea'},
  {value : 'Eritrea'},
  {value : 'Estonia'},
  {value : 'Ethiopia'},
  {value : 'Falkland Islands (Malvinas)'},
  {value : 'Faroe Islands'},
  {value : 'Fiji'},
  {value : 'Finland'},
  {value : 'France'},
  {value : 'France, Metropolitan'},
  {value : 'French Guiana'},
  {value : 'French Polynesia'},
  {value : 'French Southern Territories'},
  {value : 'Gabon'},
  {value : 'Gambia'},
  {value : 'Georgia'},
  {value : 'Germany'},
  {value : 'Ghana'},
  {value : 'Gibraltar'},
  {value : 'Greece'},
  {value : 'Greenland'},
  {value : 'Grenada'},
  {value : 'Guadeloupe'},
  {value : 'Guam'},
  {value : 'Guatemala'},
  {value : 'Guinea'},
  {value : 'Guinea-Bissau'},
  {value : 'Guyana'},
  {value : 'Haiti'},
  {value : 'Heard and Mc Donald Islands'},
  {value : 'Holy See (Vatican City State)'},
  {value : 'Honduras'},
  {value : 'Hong Kong'},
  {value : 'Hungary'},
  {value : 'Iceland'},
  {value : 'India'},
  {value : 'Indonesia'},
  {value : 'Iran (Islamic Republic of)'},
  {value : 'Iraq'},
  {value : 'Ireland'},
  {value : 'Israel'},
  {value : 'Italy'},
  {value : 'Jamaica'},
  {value : 'Japan'},
  {value : 'Jordan'},
  {value : 'Kazakhstan'},
  {value : 'Kenya'},
  {value : 'Kiribati'},
  {value : "Korea, Democratic People's Republic of"},
  {value : 'Korea, Republic of'},
  {value : 'Kuwait'},
  {value : 'Kyrgyzstan'},
  {value : "Lao People's Democratic Republic"},
  {value : 'Latvia'},
  {value : 'Lebanon'},
  {value : 'Lesotho'},
  {value : 'Liberia'},
  {value : 'Libyan Arab Jamahiriya'},
  {value : 'Liechtenstein'},
  {value : 'Lithuania'},
  {value : 'Luxembourg'},
  {value : 'Macau'},
  {value : 'Macedonia, The Former Yugoslav Republic of'},
  {value : 'Madagascar'},
  {value : 'Malawi'},
  {value : 'Malaysia'},
  {value : 'Maldives'},
  {value : 'Mali'},
  {value : 'Malta'},
  {value : 'Marshall Islands'},
  {value : 'Martinique'},
  {value : 'Mauritania'},
  {value : 'Mauritius'},
  {value : 'Mayotte'},
  {value : 'Mexico'},
  {value : 'Micronesia, Federated States of'},
  {value : 'Moldova, Republic of'},
  {value : 'Monaco'},
  {value : 'Mongolia'},
  {value : 'Montserrat'},
  {value : 'Morocco'},
  {value : 'Mozambique'},
  {value : 'Myanmar'},
  {value : 'Namibia'},
  {value : 'Nauru'},
  {value : 'Nepal'},
  {value : 'Netherlands'},
  {value : 'Netherlands Antilles'},
  {value : 'New Caledonia'},
  {value : 'New Zealand'},
  {value : 'Nicaragua'},
  {value : 'Niger'},
  {value : 'Nigeria'},
  {value : 'Niue'},
  {value : 'Norfolk Island'},
  {value : 'Northern Mariana Islands'},
  {value : 'Norway'},
  {value : 'Oman'},
  {value : 'Pakistan'},
  {value : 'Palau'},
  {value : 'Panama'},
  {value : 'Papua New Guinea'},
  {value : 'Paraguay'},
  {value : 'Peru'},
  {value : 'Philippines'},
  {value : 'Pitcairn'},
  {value : 'Poland'},
  {value : 'Portugal'},
  {value : 'Puerto Rico'},
  {value : 'Qatar'},
  {value : 'Reunion'},
  {value : 'Romania'},
  {value : 'Russian Federation'},
  {value : 'Rwanda'},
  {value : 'Saint Kitts and Nevis'},
  {value : 'Saint LUCIA'},
  {value : 'Saint Vincent and the Grenadines'},
  {value : 'Samoa'},
  {value : 'San Marino'},
  {value : 'Sao Tome and Principe'},
  {value : 'Saudi Arabia'},
  {value : 'Senegal'},
  {value : 'Seychelles'},
  {value : 'Sierra Leone'},
  {value : 'Singapore'},
  {value : 'Slovakia (Slovak Republic)'},
  {value : 'Slovenia'},
  {value : 'Solomon Islands'},
  {value : 'Somalia'},
  {value : 'South Africa'},
  {value : 'South Georgia and the South Sandwich Islands'},
  {value : 'Spain'},
  {value : 'Sri Lanka'},
  {value : 'St. Helena'},
  {value : 'St. Pierre and Miquelon'},
  {value : 'Sudan'},
  {value : 'Suriname'},
  {value : 'Svalbard and Jan Mayen Islands'},
  {value : 'Swaziland'},
  {value : 'Sweden'},
  {value : 'Switzerland'},
  {value : 'Syrian Arab Republic'},
  {value : 'Taiwan, Province of China'},
  {value : 'Tajikistan'},
  {value : 'Tanzania, United Republic of'},
  {value : 'Thailand'},
  {value : 'Togo'},
  {value : 'Tokelau'},
  {value : 'Tonga'},
  {value : 'Trinidad and Tobago'},
  {value : 'Tunisia'},
  {value : 'Turkey'},
  {value : 'Turkmenistan'},
  {value : 'Turks and Caicos Islands'},
  {value : 'Tuvalu'},
  {value : 'Uganda'},
  {value : 'Ukraine'},
  {value : 'United Arab Emirates'},
  {value : 'UK'},
  {value : 'USA'},
  {value : 'United States Minor Outlying Islands'},
  {value : 'Uruguay'},
  {value : 'Uzbekistan'},
  {value : 'Vanuatu'},
  {value : 'Venezuela'},
  {value : 'Viet Nam'},
  {value : 'Virgin Islands (British)'},
  {value : 'Virgin Islands (U.S.)'},
  {value : 'Wallis and Futuna Islands'},
  {value : 'Western Sahara'},
  {value : 'Yemen'},
  {value : 'Yugoslavia'},
  {value : 'Zambia'},
  {value : 'Zimbabwe'},
  

];


}//end class
